import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {SpinButtonView} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonView';

export class SpinButtonFreeSpinsState extends ModuleState<SpinButtonView, SpinButtonModule> {
	public static PAUSE_BEFORE_FREESPIN: number = 750;

	public onLeaveState(): void {
		this.view.show();
	}

	public onEnterState(): void {
		this.setupFreeSpinView();
	}

	protected setupFreeSpinView(): void {
		this.view.hide();
	}

	protected onCanSpin(): void {
		this.module.timeUtils.createTimer( () => {
			if (this.canStartFreeSpin()) {
				this.module.canSpin = true;
				this.emit(SpinButtonEvents.SPIN_BUTTON_PRESSED);
				this.module.canSpin = false;
			}
		}, SpinButtonFreeSpinsState.PAUSE_BEFORE_FREESPIN);

	}

	protected canStartFreeSpin(): boolean {
		return (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft > 0);
	}

	protected onFreeSpinsOutroFinished(): void {
		this.module.gotoState(SpinButtonModule.BASIC_STATE);
		this.view.enableSpinButton();
	}

	protected setupEvents(): void {
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);

		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/spinbutton/states/SpinButtonFreeSpinsState.ts